import { Create } from 'react-admin'
import Form from './form'

const CustomersUsersCreate = props => {
  return (
    <Create {...props} >
      <Form />
    </Create>
  )
}

export default CustomersUsersCreate
